img {
  max-width: 100%;
}
